import { render, staticRenderFns } from "./BranchSettings.vue?vue&type=template&id=c6384364&scoped=true&"
import script from "./BranchSettings.vue?vue&type=script&lang=js&"
export * from "./BranchSettings.vue?vue&type=script&lang=js&"
import style0 from "./BranchSettings.vue?vue&type=style&index=0&id=c6384364&lang=scss&scoped=true&"
import style1 from "./BranchSettings.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c6384364",
  null
  
)

export default component.exports